import { ChevronRightSmall } from 'ui/icons/navigation/ChevronRightSmall';
import { ChevronLeftSmall } from 'ui/icons/navigation/ChevronLeftSmall';
import { LongArrowLeft } from 'ui/icons/navigation/LongArrowLeft';
import { LongArrowRight } from 'ui/icons/navigation/LongArrowRight';
import { StyledIcon } from './Calendar.styled';
import { NavDirection, NavButtonProps } from './types';

export const DATA_TEST = {
  [NavDirection.Prev]: 'calendar-prev-nav',
  [NavDirection.Next]: 'calendar-next-nav',
};

const ICON = {
  [NavDirection.Prev]: <ChevronLeftSmall />,
  [NavDirection.Next]: <ChevronRightSmall />,
};

/**
 * the core/datepicker and core/dateRangePicker are still used in certain places, despite being deprecated.
 * they both now use the ui/calendar for their calendar, but retain the original core/ styling.
 * don't use this version.
 */
const getIcon = (direction: NavDirection, styledAsCore: NavButtonProps['styledAsCore']) => {
  if (styledAsCore) {
    return direction === NavDirection.Prev ? <LongArrowLeft /> : <LongArrowRight />;
  }

  return ICON[direction];
};

export const NavButton = ({ direction, styledAsCore }: NavButtonProps) => {
  return (
    <StyledIcon data-test={DATA_TEST[direction]} data-core={styledAsCore}>
      {getIcon(direction, styledAsCore)}
    </StyledIcon>
  );
};
